import RootPage from './appearance.page.vue'

let routes = [
  {
    path: 'appearance',
    name: 'appearance',
    component: RootPage
  },
]

export default routes
